import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import TagFilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import {
  GeneralPermissions,
  MarketingPermissions,
} from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const DiscountsItems = memo(function DiscountsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const canManageDiscounts = useHasPermission(
    GeneralPermissions.OTHER,
    MarketingPermissions.MANAGE_CAMPAIGNS,
  );
  const discountUiEnabled =
    team.featureFlags?.[FeatureFlagKey.DISCOUNT_UI] === true;

  if (!canManageDiscounts || !discountUiEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.discountsHref }}
      beta
      FilledIcon={TagFilledIcon}
      friendlyName="Discounts"
      id="discounts"
      UnfilledIcon={TagIcon}
    />
  );
});
